import { Component } from '@angular/core';
import { ToastModule } from 'primeng/toast';
import { IconComponent } from "../icon/icon.component";
import { IconName } from '@shared/models/icon-name.type';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [ToastModule, IconComponent],
  styleUrl: './toast.component.scss',
  templateUrl: './toast.component.html'
})
export class ToastComponent {

  getIcon(severity: string): IconName {
    switch (severity) {
      case 'success':
        return 'toast-success';
      case 'error':
        return 'toast-error';
      case 'warn':
        return 'toast-success';
      default:
        return 'toast-success';
    }
  }

}
